import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useRef, useState, } from "react";
import { Icon } from "../icons/Icon.js";
import { cx } from "../lib/cx.js";
const ToastContext = createContext(null);
export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx) {
        throw new Error("useToast deve ser usado dentro de ToastProvider");
    }
    return ctx;
}
const toneIcon = {
    neutral: "info",
    success: "success",
    danger: "alert",
    warning: "warning",
    info: "info",
};
export function ToastProvider({ children }) {
    const [items, setItems] = useState([]);
    const timers = useRef(new Map());
    const dismiss = useCallback((id) => {
        const t = timers.current.get(id);
        if (t)
            window.clearTimeout(t);
        timers.current.delete(id);
        setItems((prev) => prev.filter((item) => item.id !== id));
    }, []);
    const schedule = useCallback((id) => {
        const t = window.setTimeout(() => dismiss(id), 5000);
        timers.current.set(id, t);
    }, [dismiss]);
    const push = useCallback((message, tone = "neutral", action) => {
        const id = typeof crypto !== "undefined" && "randomUUID" in crypto
            ? crypto.randomUUID()
            : `toast-${Date.now()}`;
        setItems((prev) => [
            ...prev,
            {
                id,
                message,
                tone,
                ...(action ? { actionLabel: action.label, onAction: action.onAction } : {}),
            },
        ]);
        schedule(id);
    }, [schedule]);
    const value = useMemo(() => ({ push, dismiss }), [push, dismiss]);
    return (_jsxs(ToastContext.Provider, { value: value, children: [children, _jsx("div", { className: "evolua-toast-region", "aria-live": "polite", "aria-relevant": "additions", children: items.map((item) => {
                    const icon = toneIcon[item.tone];
                    return (_jsxs("div", { className: cx("evolua-toast", item.tone !== "neutral" && `evolua-toast--${item.tone}`), role: "status", onMouseEnter: () => {
                            const t = timers.current.get(item.id);
                            if (t)
                                window.clearTimeout(t);
                        }, onMouseLeave: () => schedule(item.id), children: [icon ? _jsx(Icon, { name: icon, size: 18 }) : null, _jsx("span", { className: "evolua-toast__msg", children: item.message }), item.actionLabel && item.onAction ? (_jsx("button", { type: "button", className: "evolua-toast__action", onClick: item.onAction, children: item.actionLabel })) : null, _jsx("button", { type: "button", className: "evolua-toast__close", "aria-label": "Dispensar notifica\u00E7\u00E3o", onClick: () => dismiss(item.id), children: "\u00D7" })] }, item.id));
                }) })] }));
}
//# sourceMappingURL=Toast.js.map